import { render } from "./buttoncomponent.vue?vue&type=template&id=ac58c962"
import script from "./buttoncomponent.vue?vue&type=script&lang=js"
export * from "./buttoncomponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/julien/build/build/p2p-exchange/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__